import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { iif, map, switchMap, take } from 'rxjs';
import { CoreStore } from '@core/store/core.store';
import { userRetrieved$ } from '@core/store/core-store.utils';
import { TimesheetService } from '@shared/services/timesheet.service';
import { IWeekWorktime } from '@shared/models/interfaces/week-worktime.interface';

export const userWorktimeResolver: ResolveFn<IWeekWorktime[]> = (route, state) => {
  const coreStore = inject(CoreStore);
  const timesheetService: TimesheetService = inject(TimesheetService);
  const userId: number = +(route.queryParamMap.get('userId') ?? 0);

  return userRetrieved$().pipe(
    map(() => coreStore.userId()),
    switchMap(sessionUserId => iif(
      () => !!userId,
      timesheetService.getUserWorktime(userId).pipe(
        take(1)
      ),
      timesheetService.getUserWorktime(sessionUserId ?? 0).pipe(
        take(1)
      )
    ))
  );
};
